<template>
  <div>
    <div class="head">
      <img class="img_arrow" src="@/assets/test/return.png" alt @click="goBack()">
      <p class="my_title">学员登记表</p>
      <span></span>
    </div>
    <div class="myBox">
      <p class="desc1">填写信息，让我们更了解您，以便提供更好的定制服务</p>
      <p class="desc2">信息将用于发放和查询结业证，或者查询注册考试成绩</p>
      <div class="kctitle1">
        <p>课程</p>
        <p>{{ lesson_names }}</p>
      </div>
      <div class="kctitle2">
        <p>基本信息</p>
      </div>
      <div class="kctitle3">
        <p>姓名</p>
        <span>*</span>
        <input v-model="real_name" type="text" placeholder="请输入您的姓名">
      </div>
      <div class="kctitle4">
        <div>
          <p>性别</p>
          <span>*</span>
        </div>

        <div class="xb_img">
          <img v-show="is_nan" src="@/assets/xb/xbs/nl.png" alt>
          <img v-show="!is_nan" src="@/assets/xb/xbs/nh.png" alt @click="isshow(1)">
          <p>男</p>
          <img v-show="is_nan" src="@/assets/xb/xbs/nnh.png" alt @click="isshow(2)">
          <img v-show="!is_nan" src="@/assets/xb/xbs/nf.png" alt>
          <p>女</p>
        </div>
      </div>
      <div class="kctitle7" @click="birthdaybox()">
        <div>
          <p>生日</p>
          <span>*</span>
        </div>
        <span class="zcspan">{{ birthday }}</span>
        <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle7" @click="educationbox">
        <div>
          <p>最高学历</p>
          <span>*</span>
        </div>
        <span class="zcspan">{{ education }}</span>
        <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle5">
        <p>单位</p>
        <span>*</span>
        <input v-model="work_study_place" type="text" placeholder="请输入您的单位">
      </div>
      <div class="kctitle6" style="display:flex;">
        <p>职位</p>
        <span style="color:#fff;">*</span>
        <input v-model="position" type="text" placeholder="请输入您的职位">
      </div>
      <div class="kctitle7" @click="isShow_zc">
        <div>
          <p>职称</p>
          <span>*</span>
        </div>
        <span class="zcspan">{{ zcspan }}</span>
        <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle8" @click="isShow_gznx">
        <div>
          <p>工作年限</p>
          <!-- <span>*</span> -->

        </div>
        <span class="gznxspan">{{ gznxspan }}</span>
        <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle9">
        <div>
          <p>专业</p>
          <span>*</span>
        </div>
        <input v-model="specialty" type="text" placeholder="请输入您的专业">
        <!-- <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>-->
      </div>
      <div class="kctitle9">
        <div>
          <p>毕业学校</p>
          <span>*</span>
        </div>
        <input v-model="school" type="text" placeholder="请输入您的毕业院校">
        <!-- <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>-->
      </div>
      <div class="kctitle7" @click="zjlxbox">
        <div>
          <p>证件类型</p>
          <!-- <span>*</span> -->
        </div>
        <span class="zcspan">{{ zjlxboxipt }}</span>
        <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle0">
        <p>证件号码</p>
        <!-- <span>*</span> -->
        <input v-model="id_number" type="text" placeholder="请输入证件号码">
      </div>
      <div class="id_cardMsg">
        <p style="textAlign:left;">（身份证号仅用于筑龙结业证书的查询和发布）<br>
          <span style="color:#ee2e2e !important;">不填身份证号则不可以领取证书</span>
        </p>
      </div>
      <div v-for="(item,index) in certificate" :key="index" class="kctitle8">
        <div style="display:flex;">
          <p v-show="index == 0">现有证书</p>
          <span style="color:#fff!important;">*</span>
        </div>
        <input v-if="index == 0" v-model="item.name" type="text" placeholder=" 证书名称">
        <input v-else v-model="item.name" style="padding:0 0 0 110px;" type="text" placeholder=" 证书名称">
        <div class="qxz">
          <span v-show="certificate.length!==1" style="color:#ee2e2e !important;" @click="delcertificate(index)">删除</span>
        </div>
      </div>
      <div class="kctitle02" @click="addCertificate()">

        <span style="padding:0 0 0 120px;">+ 添加证书</span>

      </div>
      <!-- 培训经历 -->
      <div>
        <div v-for="(item,index) in training" :key="index" class="kctitle8">
          <div style="display:flex;">
            <p v-show="index == 0">培训经历</p>
            <span style="color:#fff!important;">*</span>
          </div>
          <input v-if="index == 0" v-model="item.name" type="text" placeholder="培训名称">
          <input v-else v-model="item.name" style="padding:0 0 0 110px;" type="text" placeholder=" 培训名称">
          <div class="qxz">
            <span v-show="training.length!==1" style="color:#ee2e2e !important;" @click="delTraining(index)">删除</span>
          </div>
        </div>
        <div class="kctitle02" @click="addTraining()">

          <span style="padding:0 0 0 120px;">+ 添加培训</span>

        </div>
      </div>

      <!-- <div class="id_cardMsg">
        <p style="textAlign:center;">（身份证号仅用于筑龙结业证书的查询和发布）<br>
          <span style="color:#ee2e2e !important;">不填身份证号则不可以领取证书</span>
        </p>
      </div> -->
      <div class="kctitle01">
        <p>证书邮寄信息</p>
      </div>
      <div class="kctitle7" @click="phoneQzbox">
        <div>
          <p>手机区号</p>
          <span>*</span>
        </div>
        <span class="zcspan">{{ phoneQzipt }}</span>
        <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle02">
        <div>
          <p>手机</p>
          <span>*</span>
        </div>
        <input v-model="phone_number" type="value" placeholder="请输入您的手机号">
        <!-- <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>-->
      </div>
      <div class="kctitle03" @click="isShow_szdq">
        <div>
          <p>所在地区</p>
          <span>*</span>
        </div>
        <span class="szdqspan">{{ szdqspan }}</span>
        <div class="qxz1">
          <span>请选择(省)</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle03" @click="isShow_szdqshi">
        <div>
          <p>所在地区</p>
          <span>*</span>
        </div>
        <span class="szdqshispan">{{ szdqshispan }}</span>
        <div class="qxz1">
          <span>请选择(市)</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle03" @click="isShow_szdqqu">
        <div style="display: flex;">
          <p>所在地区</p>
          <span>*</span>
        </div>
        <span class="szdqshispan">{{ szdqquspan }}</span>
        <div class="qxz1">
          <span>请选择(区)</span>
          <span>></span>
        </div>
      </div>
      <div class="kctitle04">
        <div>
          <p>详细地址</p>
          <span>*</span>
        </div>
        <input v-model="address" type="text" placeholder="请输入您的详细地址">
        <!-- <div class="qxz">
          <span>请选择</span>
          <span>></span>
        </div>-->
      </div>
    </div>
    <div class="btn_commit" @click="commits()">
      <p>提交</p>
    </div>
    <!-- 职称 popup -->
    <div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
    </div>

    <!-- 工作年限 popup -->
    <div>
      <van-popup v-model="gznx" position="bottom">
        <van-picker show-toolbar :columns="columns_gznx" @confirm="onConfirm1" @cancel="gznx = false" />
      </van-popup>
    </div>

    <!-- 选择省 popup -->
    <div>
      <van-popup v-model="szdq" position="bottom">
        <van-picker show-toolbar :columns="shengList" value-key="cname" @confirm="onConfirm2" @cancel="szdq = false" />
      </van-popup>
    </div>

    <!-- 选择市 popup -->
    <div>
      <van-popup v-model="szdqshi" position="bottom">
        <van-picker show-toolbar :columns="shiList" value-key="cname" @confirm="onConfirmshi" @cancel="szdqshi = false" />
      </van-popup>
    </div>
    <!-- 选择区 popup -->
    <div>
      <van-popup v-model="szdqqu" position="bottom">
        <van-picker show-toolbar :columns="address_list_qu" value-key="cname" @confirm="onConfirmqu" @cancel="szdqqu = false" />
      </van-popup>
    </div>

    <!-- 最高学历 popup -->
    <div>
      <van-popup v-model="educationPOP" position="bottom">
        <van-picker show-toolbar :columns="educationRES" value-key="education" @confirm="onConfirmeducation" @cancel="educationPOP = false" />
      </van-popup>
    </div>

    <!-- 证件类型 -->
    <div>
      <van-popup v-model="zjlxboxPOP" position="bottom">
        <van-picker show-toolbar :columns="id_number_typeRES" @confirm="onConfirmZjlx" @cancel="zjlxboxPOP = false" />
      </van-popup>
    </div>

    <!-- 手机号前缀 ephoneQzPOP -->
    <div>
      <van-popup v-model="ephoneQzPOP" position="bottom">
        <van-picker show-toolbar :columns="phone_number_preRES" value-key="cnprefix" @confirm="onConfirmphoneQz" @cancel="ephoneQzPOP = false" />
      </van-popup>
    </div>
    <div>
      <van-popup v-model="birthdayPicker" position="bottom">
        <van-datetime-picker v-model="birthdayone" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmdate" @cancel="birthdayPicker = false" />
      </van-popup>

    </div>
  </div>
</template>

<script>
import { getPersonal, get_info } from '@/api/student.js'
import { get_sheng } from '@/api/address.js'
import Cookie from 'js-cookie'
import { Toast } from 'vant'
import tool from '@/utils/tools.js'
export default {

  data() {
    return {
      birthdayone: new Date(1990, 0o0, 0o1),
      minDate: new Date(1940, 0, 1),
      maxDate: new Date(2025, 10, 1),
      birthdayPicker: false,
      quid: '',
      szdqquspan: '',
      address_list_qu: [],
      shiList: [],
      szdqshi: false,
      szdqqu: false,
      szdqspan: '',
      phoneQzipt: '',
      shengList: [],
      educationRES: [],
      id_number_typeRES: [],
      phone_number_preRES: [],
      certificate: [{ name: '' }], // 证书
      training: [{ name: '' }], // 培训经历
      id_number_type: null, // 证件类型
      phone_number_pre: '', // 手机号前缀
      gznxspan: '',
      zcspan: '',
      address: '',
      phone_number: '',
      id_number: '',
      specialty: '',
      school: '',
      zjlxboxipt: '',
      post_appellation: '',
      position: '',
      work_study_place: '',
      birthday: '',
      gender: 1,
      real_name: '',
      ephoneQzPOP: false,
      szdq: false,
      gznx: false,
      is_nan: true,
      educationPOP: false,
      courseName: 'test course name ',
      name: '',
      columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
      columns_gznx: [],
      showPicker: false,
      zjlxboxPOP: false,
      zc_value: '',
      szdqobj: {},
      gznx_value: '',
      zy_value: '',
      lesson_names: '',
      shengid: '',
      szdqshispan: '',
      years: '',
      shiid: '',
      educationIndex: '',
      education: ''
    }
  },
  mounted() {
    tool.isLogin()

    // this.years = 4
    // console.log(this.years)
    // this.getaddress()
    // this.get_info()
    this.getsheng()
  },
  methods: {
    onConfirmdate() {
      this.birthday = tool.formatDate(this.birthdayone, 'yyyy-MM-dd')
      console.log(this.birthday)
      this.birthdayPicker = false
    },
    stringToDate(str) {
      let date = ''
      if (!str) return date
      const tempStrs = str.split(' ')
      const dateStrs = tempStrs[0].split('-')
      const year = parseInt(dateStrs[0], 10)
      const month = parseInt(dateStrs[1], 10) - 1
      const day = parseInt(dateStrs[2], 10)
      date = new Date(year, month, day)
      return date
    },

    birthdaybox() {
      this.birthdayPicker = true
      console.log(123)
    },
    delTraining(index) {
      this.training.splice(index, 1)
    },
    addTraining() {
      this.training.push({ name: '' })
    },
    delcertificate(index) {
      this.certificate.splice(index, 1)
    },
    addCertificate() {
      this.certificate.push({ name: '' })
    },
    async getsheng() {
      var params = {
        parent_id: '',
        level: 1
      }
      var fn = await get_sheng(params)
      this.shengList = fn.result
      var mydata = {
        lesson_id: this.$route.query.lesson_id
      }
      get_info(mydata).then(res => {
        this.lesson_names = res.result.lesson_name
        // 拿config默认数据
        this.educationRES = res.result.config.education
        this.phone_number_preRES = res.result.config.phone_number_pre
        this.columns_gznx = Object.values(res.result.config.work_years)
        this.columns = res.result.config.post_appellation
        this.id_number_typeRES = Object.values(res.result.config.id_number_type)
        this.phone_number_preRES = res.result.config.phone_number_pre
        this.phone_number_preRES.forEach((item) => {
          item.cnprefix = item.cn + '+' + item.prefix
        })
        // 拿config默认数据结束

        var data = res.result.info
        if (data !== null) {
          this.phone_number_pre = data.phone_number_pre
          // 保存后回显
          // 用户名
          this.real_name = data.real_name
          // new
          // 生日
          this.birthday = data.birthday
          this.birthdayone = this.stringToDate(this.birthday)
          // 学历
          this.educationRES.forEach(ele => {
            if (ele.id == data.education) {
              this.education = ele.education
            }
          })
          this.educationIndex = data.education
          this.school = data.school
          this.zjlxboxipt = this.id_number_typeRES[data.id_number_type - 1]
          this.id_number_type = data.id_number_type
          if (data.certificate !== null) {
            this.certificate = JSON.parse(data.certificate)
          }
          if (data.training !== null) {
            this.training = JSON.parse(data.training)
          }
          // new
          this.gender = data.gender
          this.gender === 1 ? this.is_nan = true : this.is_nan = false
          this.work_study_place = data.work_study_place
          this.position = data.position
          this.zc_value = data.post_appellation
          this.years = data.work_years
          this.gznxspan = Object.values(res.result.config.work_years)[this.years - 1]
          this.zcspan = res.result.config.post_appellation[data.post_appellation]
          this.specialty = data.specialty
          this.id_number = data.id_number
          this.phone_number = data.phone_number
          this.address = data.address
          this.shengid = data.province_id
          this.shiid = data.city_id
          this.quid = data.county_id
          this.phone_number_preRES.forEach(ele => {
            ele.cnprefix = ele.cn + '+' + ele.prefix
            if (ele.id == data.phone_number_pre) {
              this.phoneQzipt = ele.cnprefix
            }
          })
          // debugger
          if (this.shengList.length > 0) {
            this.shengList.forEach((item) => {
              if (item.id == data.province_id) {
                this.szdqspan = item.cname
                var params = {
                  parent_id: data.province_id
                }
                get_sheng(params).then(res => {
                  this.shiList = res.result
                  console.log(this.shiList, 'this.shiList')
                  this.shiList.forEach((e) => {
                    if (e.id == data.city_id) {
                      this.szdqshispan = e.cname
                    }
                  })
                })
              }
            })
            var params = {
              parent_id: this.shiid
            }
            get_sheng(params).then((res) => {
              this.address_list_qu = res.result
              if (this.address_list_qu) {
                this.address_list_qu.forEach(item1 => {
                  if (item1.id == this.quid) {
                    this.szdqquspan = item1.cname
                  }
                })
              }
            })
          }
        }
      })
    },
    goBack() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    },
    commits() {
      if (this.shengid === '' || this.shiid === '' || this.address === '' || this.shiid === '') {
        Toast('请完善地址信息')
        return
      }
      if (this.work_study_place == '') {
        Toast('请填写单位信息')
        return
      }
      if (this.specialty == '') {
        Toast('请填写专业')
        return
      }
      if (this.school == '') {
        Toast('请填写毕业院校')
        return
      }

      // if (this.id_number == '') {
      //   Toast('请填写证件号码')
      //   return
      // }
      if (this.phone_number_pre == '') {
        Toast('请填写手机区号')
        return
      }
      if (this.real_name == '') {
        Toast('请填写姓名')
        return
      }
      if (this.birthday == '') {
        Toast('请填写正确的生日')
        return
      }
      if (this.educationIndex == '') {
        Toast('请填写最高学历')
        return
      }
      // if (this.id_number_type == null) {
      //   Toast('请填写证件类型')
      //   console.log(this.id_number_type)
      //   return
      // }
      var params = {
        birthday: this.birthday,
        id_number_type: this.id_number_type,
        phone_number_pre: this.phone_number_pre,
        certificate: JSON.stringify(this.certificate),
        training: JSON.stringify(this.training),
        school: this.school,
        education: this.educationIndex,
        real_name: this.real_name,
        gender: this.gender,
        work_study_place: this.work_study_place,
        position: this.position,
        post_appellation: this.zc_value,
        work_years: this.years,
        specialty: this.specialty,
        id_number: this.id_number,
        phone_number: this.phone_number,
        address: this.address,
        province_id: this.shengid,
        city_id: this.shiid,
        county_id: this.quid
      }

      console.log(params)
      getPersonal(params).then(res => {
        if (res.errNo !== 0) {
          Toast(res.msg)
        } else {
          Toast('提交成功')
          window.location.href = 'https://m.zhulong.com/ucenter/index/my_curriculum'
        }
      })
    },
    zcVal() {
      console.log()
    },
    isShow_zc() {
      this.showPicker = true
    },
    educationbox() {
      this.educationPOP = true
    },
    phoneQzbox() {
      this.ephoneQzPOP = true
    },
    zjlxbox() {
      this.zjlxboxPOP = true
    },
    isShow_gznx() {
      this.gznx = true
    },
    isShow_szdq() {
      this.szdq = true
    },
    isShow_szdqshi() {
      this.szdqshi = true
    },
    isShow_szdqqu() {
      this.szdqqu = true
    },
    onConfirmphoneQz(value, index) {
      this.phone_number_pre = value.id
      console.log(this.phone_number_pre)
      this.phoneQzipt = value.cnprefix
      this.ephoneQzPOP = false
    },
    onConfirmZjlx(value, index) {
      this.id_number_type = index + 1
      this.zjlxboxipt = value
      this.zjlxboxPOP = false
    },
    onConfirmeducation(value, index) {
      this.educationIndex = value.id
      this.education = value.education
      this.educationPOP = false
    },
    onConfirm(value, index) {
      this.zc_value = index
      this.zcspan = value
      this.showPicker = false
    },
    onConfirm1(value, index) {
      this.gznx_value = value
      this.years = index + 1
      console.log(this.years)
      this.gznxspan = value
      this.gznx = false
    },
    onConfirm2(value) {
      console.log(value)
      this.szdqobj = value
      this.szdqspan = value.cname
      this.szdq = false
      this.shengid = value.id
      // 置空市qu级
      this.szdqshispan = ''
      this.shiid = ''
      this.szdqquspan = ''
      this.quid = ''
      var params = {
        parent_id: this.shengid
      }
      get_sheng(params).then(res => {
        this.shiList = res.result
      })
    },

    onConfirmqu(value) {
      this.szdqquspan = value.cname
      this.quid = value.id
      this.szdqqu = false
    },
    onConfirmshi(value) {
      this.szdqshispan = value.cname
      this.shiid = value.id
      // 获取市id对应的区列表

      var params = {
        parent_id: this.shiid
      }
      get_sheng(params).then((res) => {
        this.address_list_qu = res.result
      })

      this.szdqshi = false
    },
    isshow(type) {
      if (type === 1) {
        this.is_nan = true
        this.gender = 1
      } else if (type === 2) {
        this.is_nan = false
        this.gender = 2
      }
    },
    submitForm() {
      if (!this.validate()) {
        return
      }
      this.getStudent()
    },
    validate() {
      if (!this.name) return false
      if (!this.address) return false

      return true
    }

  },
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f7f7f7'
    next()
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  }
}
</script>

<style scoped lang="scss">
.szdqshispan {
  padding-right: 200px;
  color: #333333 !important;
}
.szdqspan {
  padding-right: 200px;
  color: #333333 !important;
}
.zcspan {
  width: 42%;
  text-align: left;
  color: #333333 !important;
}
.gznxspan {
  padding-right: 120px;
  color: #333333 !important;
}
.myBox {
  width: 100%;
  padding-bottom: 120px;
  margin-top: 100px;
  overflow: hidden;
  overflow-y: auto;
}
.id_cardMsg {
  width: 100%;
  height: 60px;
  padding:20px 0;
  display: flex;
  align-items: center;
  p {
    color: #999999;
    position: relative;
    z-index:-1;
    left: 225px;
  }
}
.qxz1 {
  width: 200px;
  height: 36px;
  text-align: right;
  margin-right: 30px;
}
.qxz1 span:nth-child(1) {
  color: #999999 !important;
  display: inline-block;
}
.qxz1 span:nth-child(2) {
  color: #999999 !important;
  padding-left: 10px;
}
.qxz {
  width: 160px;
  height: 36px;
  margin-right: 30px;
  text-align: right;
}
.qxz span {
  color: #999999 !important;
  // display: inline-block;
  // width: 160px;
}
.qxz span:nth-child(2) {
  color: #999999 !important;
  padding-left: 10px;
}
.xb_img {
  width: 285px;
  height: 70px;
  // background: chocolate;
  margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 60px;
    height: 60px;
  }
  p {
    color: #333333;
  }
}
.btn_commit {
  width: 100%;
  height: 110px;
  background: #ee2e2e;
  position: fixed;
  bottom: 0;
  p {
    text-align: center;
    line-height: 98px;
    color: #fff;
    font-size: 36px;
    letter-spacing: 3px;
  }
}
.kctitle01 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  p:nth-child(1) {
    width: 209px;
    // color: #ccc;
    // text-align: justify;
    // text-align-last: justify;
    margin-left: 15px;
    padding-left: 10px;
    color: #333333;
    font-size: 30px;
    border-left: 5px solid #ee2e2e;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle1 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
    font-size: 30px;
  }
}
.kctitle2 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    margin-left: 15px;
    padding-left: 10px;
    color: #333333;
    font-size: 30px;
    border-left: 5px solid #ee2e2e;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle3 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  // ruby-span: ;
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  span {
    color: red;
    font-size: 30px;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle4 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
    display: inline-block;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle5 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle6 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle7 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }

  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
    display: inline-block;
  }
}
.kctitle8 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
    display: inline-block;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle9 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
    display: inline-block;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle0 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  span {
    color: red;
    font-size: 30px;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle02 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
    display: inline-block;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle03 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
    display: inline-block;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.kctitle04 {
  width: 100%;
  height: 105px;
  background: #fff;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  span {
    color: red;
    font-size: 30px;
  }
  input {
    padding-left: 30px;
    padding-top: 5px;
    font-size: 30px;
    color: #333;
  }
  p:nth-child(1) {
    width: 160px;
    // color: #ccc;
    text-align: justify;
    text-align-last: justify;
    padding-left: 30px;
    color: #333333;
    font-size: 30px;
    display: inline-block;
  }
  p:nth-child(2) {
    padding-right: 30px;
    color: #333333;
  }
}
.my_title {
  color: #333;
  font-size: 34px;
  /* font-weight: 600; */
  letter-spacing: 2px;
  padding-right: 60px;
}
.img_arrow {
  width: 55px;
  height: 60px;
  padding-left: 30px;
  padding-top: 0px;
}
.head {
  width: 100%;
  height: 90px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  border-bottom: 1px solid #eee;
}
.basic-box {
  margin-top: 5px;
  margin-bottom: 10px;
}
.required-start {
  color: red;
}
.van-cell__title {
  text-align: left;
}
.basic-info {
  position: relative;
  margin-left: 5px;
  font-weight: bold;
  color: black;
}
.basic-info::before {
  content: "";
  width: 2px;
  height: 20px;
  background: red;
  position: absolute;
  left: -10px;
}
.deliver-box {
  margin-bottom: 30px;
}
.desc1 {
  color: #999999;
  font-size: 24px;
  // text-align: center;
  padding: 20px 0 5px 40px;
}
.desc2 {
  color: #ee2e2e;
  font-size: 24px;
  // text-align: center;
  padding: 5px 0 20px 40px;
}
</style>
